import { Button, ButtonProps } from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Link from "@pathwright/ux/src/components/link/Link"
import Pathicon from "@pathwright/features/src/modules/pathicon/Pathicon"

type SuggestedActionProps = {
  label: string | JSX.Element
  icon?: IconName | JSX.Element
  url?: string
  onClick?: () => void
} & ButtonProps

const SuggestedAction = ({
  icon,
  label,
  url,
  onClick,
  ...buttonProps
}: SuggestedActionProps) => {
  // const colorPalette = useColorModeValue("gray")

  const children = (
    <>
      {typeof icon === "string" ? <Pathicon icon={icon} /> : icon}
      {label}
    </>
  )

  return url ? (
    <Button
      className="SuggestedAction"
      asChild
      variant="outline"
      size="sm"
      colorPalette="whiteAlpha"
      {...buttonProps}
    >
      <Link
        to={url}
        onClick={onClick}
        variant="plain"
        textDecor="none !important"
      >
        {children}
      </Link>
    </Button>
  ) : (
    <Button
      className="SuggestedAction"
      variant="outline"
      size="sm"
      px={5}
      py={3}
      onClick={onClick}
      colorPalette="whiteAlpha"
      {...buttonProps}
    >
      {children}
    </Button>
  )
}

export default SuggestedAction
